module.exports = __webpack_public_path__ + "img/29-Oregon 3.jpg";